import { PureComponent } from 'react';

import Field from './Field';

class RadioField extends PureComponent {
    handleChange = (e, form, field) => {
        if (this.props.onChange) {
            this.props.onChange(e, form, field);
        }
        form.handleChange(e);
    };

    handleBlur = (e, form, field) => {
        if (this.props.onBlur) {
            this.props.onBlur(e, form, field);
        }

        form.handleBlur(e);
    };

    renderInput = props => {
        const { form, field } = props;
        const { className, value, label, readOnly } = this.props;

        if (field.value == null) {
            field.value = '';
        }

        const attrs = {
            ...field,
            className
        };

        if (attrs.className) {
            attrs.className = 'form-field-control ' + attrs.className;
        } else {
            attrs.className = 'form-field-control';
        }

        if (readOnly) {
            attrs.className = attrs.className + ' read-only';
        }

        return (
            <div className="radio-group">
				<label htmlFor={this.props.id} style={{ cursor: 'pointer' }}>
					<input
						{...attrs}
						type="radio"
						id={this.props.id}
						value={value}
						checked={`${value}` == `${field.value}` ? true : false}
						readOnly={readOnly ? true : ''}
						onChange={e => {
							this.handleChange(e, form, field);
						}}
						onBlur={e => {
							this.handleBlur(e, form, field);
						}}
						style={{ cursor: 'pointer', marginRight: '10px' }}
					/>
					{label}
				</label>
            </div>
        );
    };

    render() {
        return <Field {...this.props} label={null} className="form-field-radio" render={props => this.renderInput(props)} />;
    }
}

export default RadioField;
